export default class User {
    id: number;
    roles: string[];

    constructor(data: any) {
        this.id = data.id;
        this.roles = data.roles || [];
    }

    public isInRole(role: string): boolean {
        return this.roles.some(r => r.toLowerCase() === role.toLowerCase());
    }
}
